/**
 * @file ppde页面
 * @author FengGuang(fengguang01@baidu.com)
 */
import {useEffect, useState} from 'react';
import {fetchGetPpdeInfo} from '../../api/pages/ppdeApi';
import {IMembersProps} from './components/members/types';
import {IFeaturedCaseProps} from './components/featured-cases/types';
import {IAboutUsProps} from './components/about-us/types';
import {IBannerPictureCardGroupProps} from './components/banner-picture-card/types';

// 预请求
let preRequest: any = {
    fetchGetPpdeInfo: fetchGetPpdeInfo()
};


const usePpdeHooks = () => {
    const [bannerPictureCard, setBannerPictureCard] = useState<IBannerPictureCardGroupProps>(() => {
        return {list: [{}, {}, {}, {}]};
    });
    const [members, setMembers] = useState<IMembersProps>(() => {
        return {
            list: Array(5).fill(Array(8).fill(undefined))
        };
    });
    const [featuredCase, setFeaturedCase] = useState<IFeaturedCaseProps>(() => {
        return {
            list: Array(5).fill(undefined)
        };
    });
    const [aboutUs, setAboutUs] = useState<IAboutUsProps>(() => {
        return {
            video: undefined,
            list: Array(4).fill(undefined)
        };
    });

    useEffect(() => {
        (async () => {
            const fetchFunc = preRequest.fetchGetPpdeInfo || fetchGetPpdeInfo();
            delete preRequest.fetchGetPpdeInfo;

            const res = await fetchFunc.catch(() => {
                // ignore
            });
            if (res) {
                const pageData = res.body.result?.pageData || {};

                const bpc = pageData.bannerPictureCard || {};
                const bpcList: any[] = Array.isArray(bpc.list) ? bpc.list : [];
                setBannerPictureCard({
                    list: bpcList.map((item, index) => {
                        return {
                            key: `${item.title}${index}`,
                            title: item.title,
                            text: item.text,
                            img: item.img,
                            link: item.link,
                            btnText: item.btnText
                        };
                    })
                });

                const mb = pageData.member || {};
                const mbGroup: any[] = Array.isArray(mb.group) ? mb.group : [];
                setMembers({
                    list: mbGroup.map((theList) => {
                        const l: any[] = Array.isArray(theList) ? theList : [];
                        return l.map(item => ({
                            company: item.company,
                            img: item.img,
                            link: item.link,
                            name: item.name,
                            size: item.sizeLarge ? 'large' : undefined,
                            position: item.position
                        }));
                    })
                });

                const fc = pageData.featuredCase || {};
                const fcList: any[] = Array.isArray(fc.list) ? fc.list : [];
                setFeaturedCase({
                    list: fcList.map(item => ({
                        title: item.title,
                        subtitle: item.subtitle,
                        text: item.text,
                        img: item.img,
                        link: item.link
                    }))
                });

                const au = pageData.aboutUs || {};
                const auVideo: { [key: string]: string } = au.video || {};
                const auList: any[] = Array.isArray(au.list) ? au.list : [];
                setAboutUs({
                    video: {
                        coverImg: auVideo.coverImg,
                        coverVideo: auVideo.coverVideo,
                        video: auVideo.video
                    },
                    list: auList.map(item => ({
                        title: item.title,
                        img: item.img,
                        link: item.link
                    }))
                });
            }
        })();
    }, []);

    return {
        bannerPictureCard,
        members,
        featuredCase,
        aboutUs
    };
};

export default usePpdeHooks;
